import type {
  KinesisExtensionConfiguration,
  KinesisStreamsWithConsumer,
  MqttToKinesisRoute,
} from '@/generated/http-clients/v3ApiSchemas'
import get from 'lodash/get'

// biome-ignore lint/suspicious/noExplicitAny: a value can be of any type here
export function ensureObject(value: any): Record<string, any> {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? value
    : {}
}
function transformKinesisStream(
  // biome-ignore lint/suspicious/noExplicitAny: data is close to KinesisStreamsWithCustomer but a flattened version
  kinesisStreamData: any,
): KinesisStreamsWithConsumer {
  const output: KinesisStreamsWithConsumer = {
    'kinesis-stream': {
      ...kinesisStreamData,
      'partition-key': {
        'mqtt-topic': ensureObject(
          get(kinesisStreamData, 'partition-key.mqtt-topic'),
        ),
      },
      'explicit-hash-key': {
        random: ensureObject(
          get(kinesisStreamData, 'explicit-hash-key.random'),
        ),
      },
    },
  }
  return output
}

function transformMqttToKinesisRoute(
  // biome-ignore lint/suspicious/noExplicitAny: data is close to MqttToKinesisRoute but a flattened version
  mqttToKinesisRouteData: any,
): MqttToKinesisRoute {
  const route: MqttToKinesisRoute = {
    'mqtt-to-kinesis-route': {
      ...mqttToKinesisRouteData,
      'mqtt-topic-filters': [get(mqttToKinesisRouteData, 'mqtt-topic-filters')],
      processor: {
        mapping: {
          'kinesis-streams': [
            get(mqttToKinesisRouteData, 'processor.mapping.kinesis-streams'),
          ].map((stream) =>
            transformKinesisStream(get(stream, 'kinesis-stream')),
          ),
        },
      },
    },
  }
  return route
}

// biome-ignore lint/suspicious/noExplicitAny: data is close to KinesisExtensionConfiguration but a flattened version
export function kinesisTransform(json: any): KinesisExtensionConfiguration {
  const kinesisConfig: KinesisExtensionConfiguration = {
    'hivemq-amazon-kinesis-extension': {
      'aws-credential-profiles': [
        get(json, 'hivemq-amazon-kinesis-extension.aws-credential-profiles'),
      ],
      'mqtt-to-kinesis-routes': [
        get(json, 'hivemq-amazon-kinesis-extension.mqtt-to-kinesis-routes'),
      ].map((route) =>
        transformMqttToKinesisRoute(get(route, 'mqtt-to-kinesis-route')),
      ),
    },
  }
  return kinesisConfig
}
